<form [formGroup]="selectForm">
  <mat-form-field class="select-field" color="accent">
    <mat-select formControlName="select" [placeholder]="'FILTER_ENGINE.PLACEHOLDER' | translate" (selectionChange)="onSelectionChange()">
      <mat-option [value]="option" *ngFor="let option of data.list">{{ option.value | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
</form>
